import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../pages/header/header.component'
import { FooterComponent } from '../../pages/footer/footer.component';
// import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-dashboad-layout',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './dashboad-layout.component.html',
  styleUrl: './dashboad-layout.component.scss'
})
export class DashboadLayoutComponent {

}
